/**
 * The phone calendar's place, in the URL, beside the calendar's own
 * parameters (`calendar-url.ts`, which keeps parameters it does not own):
 *
 *   /tasks?view=calendar&ptab=today&sheet=occ:sched_1:1792970880000
 *
 * The tab, so a reload keeps it; the open sheet, so the phone's Back
 * closes it (the sheet is pushed as its own history entry). Bad values
 * read as the default, as everywhere in the calendar's URL.
 */
import type { PhoneTab } from './phone-model';

export interface PhoneUrlState {
  tab: PhoneTab;
  /** What the open sheet shows: a lane item id, `burst:<first item id>`
   *  or `schedule:<schedule id>`; null when closed. */
  sheet: string | null;
}

export function parsePhoneUrl(p: URLSearchParams): PhoneUrlState {
  const tab = p.get('ptab');
  const sheet = (p.get('sheet') ?? '').slice(0, 200);
  return {
    tab: tab === 'today' || tab === 'schedules' ? tab : 'now',
    sheet: sheet || null,
  };
}

export function writePhoneUrl(prev: URLSearchParams, patch: Partial<PhoneUrlState>): URLSearchParams {
  const next = new URLSearchParams(prev);
  const state = { ...parsePhoneUrl(prev), ...patch };
  if (state.tab === 'now') next.delete('ptab');
  else next.set('ptab', state.tab);
  if (state.sheet) next.set('sheet', state.sheet);
  else next.delete('sheet');
  return next;
}
